import { render } from "./TheLanguages.vue?vue&type=template&id=108c4c3f"
import script from "./TheLanguages.vue?vue&type=script&lang=js"
export * from "./TheLanguages.vue?vue&type=script&lang=js"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__